import gsap from 'gsap';

export default function links() {
  const content = document.querySelector('.js-content-with-buttons');
  const rooms = document.querySelectorAll('.js-room');
  const hoverScales = document.querySelectorAll('.js-hover-scale');
  const primaryButtons = document.querySelectorAll('.js-primary-btn');
  const iconButtons = document.querySelectorAll('.js-icon-btn');
  const hiddenEmails = document.querySelectorAll('.js-email');

  const rentalTabsLinks = document.querySelectorAll('.js-tab-trigger');
  const aboutTabsLinks = document.querySelectorAll('.js-tab-about');

  const shortFilterRooms = document.querySelector('.js-short-filter');
  const longFilterRooms = document.querySelector('.js-long-filter');
  const headerRoomsBtnShort = document.querySelectorAll('.js-check-tabs-short');
  const headerRoomsBtnLong = document.querySelectorAll('.js-check-tabs-long');

  if (aboutTabsLinks.length > 0) {
    for (const tabLink of aboutTabsLinks) {
      tabLink.addEventListener('click', (e) => {
        if (document.querySelector('.js-tab-about.active-tab')) {
          document
            .querySelector('.js-tab-about.active-tab')
            .classList.remove('active-tab');
        }

        if (document.querySelector('.tab-c[id].active')) {
          document
            .querySelector('.tab-c[id].active')
            .classList.remove('active');
        }
        e.target.classList.add('active-tab');
        var tab = document.querySelector(
          '.tab-c[id="' + e.target.getAttribute('data-href') + '"]'
        );
        tab.classList.add('active');

        if (window.innerWidth < 1280) {
          setTimeout(() => {
            window.scrollTo(0, tab.offsetTop - 80);
          }, 0);
        }
      });
    }
  }

  if (rentalTabsLinks.length > 0) {
    for (const tabLink of rentalTabsLinks) {
      tabLink.addEventListener('click', (e) => {
        if (document.querySelector('.js-tab-trigger.active')) {
          document
            .querySelector('.js-tab-trigger.active')
            .classList.remove('active');
        }

        if (document.querySelector('.tab-c[data-id].active')) {
          document
            .querySelector('.tab-c[data-id].active')
            .classList.remove('active');
        }
        e.target.classList.add('active');
        document
          .querySelector(
            '.tab-c[data-id="' + e.target.getAttribute('data-slug') + '"]'
          )
          .classList.add('active');
      });
    }
  }


  //TODO: WHY this here and not in form.js???????
  const customSlc = document.querySelectorAll('.js-form-field-custom');
  if (customSlc.length > 0) {
    for (const checkboxS of customSlc) {
      checkboxS.addEventListener('change', (e) => {
        var parent =
          e.target.parentNode.parentNode.parentNode.parentNode.parentNode
            .parentNode;
        var select = parent.querySelector('select');

        if (e.target.checked) {
          for (const subCheck of parent.querySelectorAll(
            '.js-form-field-custom'
          )) {
            if (subCheck.getAttribute('value') != e.target.value) {
              subCheck.checked = false;
            }
          }
          select.value = e.target.value;
        } else {
          select.value = '';
        }
      });
    }
  }
  // MOVED and updated to roomsFilter.js
  // if (shortFilterRooms) {
  //   shortFilterRooms.addEventListener('click', () => {
  //     shortFilterRooms.classList.add('active');
  //     longFilterRooms.classList.remove('active');
  //     const allRooms = document.querySelectorAll('.room-item');
  //     const longRoomsPrices = document.querySelectorAll(
  //       '[data-price="regular"]'
  //     );
  //     const shortRoomsPrices = document.querySelectorAll(
  //       '[data-price="short"]'
  //     );
  //     if (allRooms.length > 0) {
  //       for (const allRoom of allRooms) {
  //         if (allRoom.getAttribute('data-short')) {
  //           allRoom.classList.remove('hidden');
  //         } else {
  //           allRoom.classList.add('hidden');
  //         }
  //       }
  //     }
  //     if (longRoomsPrices.length > 0) {
  //       for (const longRoomPrice of longRoomsPrices) {
  //         longRoomPrice.classList.add('hidden');
  //       }
  //     }
  //     if (shortRoomsPrices.length > 0) {
  //       for (const shortRoomsPrice of shortRoomsPrices) {
  //         shortRoomsPrice.classList.remove('hidden');
  //       }
  //     }
  //   });
  // }

  var event = navigator.userAgent.match(/(iPad|iPhone|iPod)/g)
    ? 'touchstart'
    : 'click';



  // jQuery(document).on(event, function (e) {
  //   if (jQuery(e.target).closest('.top-select').length === 0) {
  //     jQuery('.top-select').removeClass('hover');
  //   }
  // });
  //
  //
  // jQuery(document).on('click', '.top-select button', function () {
  //   if (jQuery(this).parent().hasClass('hover')) {
  //     jQuery('.top-select').removeClass('hover');
  //   } else {
  //     jQuery('.top-select').removeClass('hover');
  //     jQuery(this).parent().addClass('hover');
  //   }
  //   return false;
  // });

  document.addEventListener(event, function (e) {
    if (!e.target.closest('.top-select')) {
      document.querySelectorAll('.top-select').forEach(function(el) {
        el.classList.remove('hover');
      });
    }
  });

  document.addEventListener('click', function(e) {

    if (e.target.closest('.top-select button')) {
      const parent = e.target.closest('.top-select');

      if (parent.classList.contains('hover')) {
        document.querySelectorAll('.top-select').forEach(function(el) {
          el.classList.remove('hover');
        });
      } else {
        document.querySelectorAll('.top-select').forEach(function(el) {
          el.classList.remove('hover');
        });
        parent.classList.add('hover');
      }

      e.preventDefault();
      return false;
    }
  });

  //
  // MOVED: TO VIDEOS.JS and rewrote in vanilla js
  // jQuery(document).on('click', '.js-video-play', function () {
  //   if (jQuery(this).find('svg').eq(0).hasClass('hidden')) {
  //     jQuery(this).find('video:visible')[0].pause();
  //   } else {
  //     jQuery(this).find('video:visible')[0].play();
  //   }
  //   jQuery(this).find('svg').toggleClass('hidden');
  //
  //   return false;
  // });
  // $('.js-video-play').trigger('click');

  const clickCitiesDrop = document.querySelector('.top-select button');
  if (clickCitiesDrop) {
    clickCitiesDrop.addEventListener('click', () => {
      // alert();
      // if (this.classList.includes('hover')) {
      //   this.classList.remove('hover');
      // } else {
      //   this.classList.add('hover');
      // }
    });
  }

  // MOVED and updated to roomsFilter.js
  // if (longFilterRooms) {
  //   longFilterRooms.addEventListener('click', () => {
  //     shortFilterRooms.classList.remove('active');
  //     longFilterRooms.classList.add('active');
  //     const shortRooms = document.querySelectorAll('.room-item');
  //     const longRoomsPrices = document.querySelectorAll(
  //       '[data-price="regular"]'
  //     );
  //     const shortRoomsPrices = document.querySelectorAll(
  //       '[data-price="short"]'
  //     );
  //     if (shortRooms.length > 0) {
  //       for (const shortRoom of shortRooms) {
  //         shortRoom.classList.remove('hidden');
  //       }
  //     }
  //     if (longRoomsPrices.length > 0) {
  //       for (const longRoomPrice of longRoomsPrices) {
  //         longRoomPrice.classList.remove('hidden');
  //       }
  //     }
  //     if (shortRoomsPrices.length > 0) {
  //       for (const shortRoomsPrice of shortRoomsPrices) {
  //         shortRoomsPrice.classList.add('hidden');
  //       }
  //     }
  //   });
  // }

  if (headerRoomsBtnShort) {
    headerRoomsBtnShort.forEach((element) => {
      element.addEventListener('click', function (e) {
        if (
          element.getAttribute('href').includes('#short') &&
          shortFilterRooms
        ) {
          shortFilterRooms.click();
          e.preventDefault();
        }
      });
    });
  }

  if (headerRoomsBtnLong) {
    headerRoomsBtnLong.forEach((element) => {
      element.addEventListener('click', function (e) {
        if (
          element.getAttribute('href').includes('#long') &&
          shortFilterRooms
        ) {
          longFilterRooms.click();
          e.preventDefault();
        }
      });
    });
  }

  if (
    window.location.hash &&
    window.location.hash == '#short' &&
    shortFilterRooms
  ) {
    shortFilterRooms.click();
  }

  if (hiddenEmails.length > 0) {
    for (const email of hiddenEmails) {
      email.addEventListener('click', () => {
        window.location.href =
          'mailto:' + email.dataset.name + email.dataset.domain;
      });
    }
  }

  if (content) {
    const links = content.querySelectorAll('a');

    if (!links) return false;

    for (let link of links) {
      const img = document.createElement('img');
      // const img = document.createElement('video');
      // img.setAttribute('loop', '');
      // img.setAttribute('autoplay', '');
      img.src = link.href;
      link.appendChild(img);
      link.href = 'javascript: void(0)';
    }
  }

  if (hoverScales) {
    for (let hoverScale of hoverScales) {
      const section = hoverScale.closest('section');
      const sectionBg = section.querySelector('.js-bg-full');

      if (!sectionBg) return false;

      const sectionBgInside = sectionBg.querySelector('div');
      const sectionAnimation = gsap.timeline().pause(0);

      sectionAnimation.fromTo(
        sectionBgInside,
        {
          scale: 1,
          ease: 'power3.in',
        },
        {
          scale: 1.05,
          ease: 'power2.out',
          duration: 1.2,
        }
      );

      hoverScale.addEventListener('mouseenter', () => {
        sectionAnimation.play();
      });

      hoverScale.addEventListener('mouseleave', () => {
        sectionAnimation.reverse();
      });
    }
  }

  ////
  // if(rooms && window.outerWidth >= 1280) {

  //     for(let room of rooms) {

  // const roomPosition = (room) => {
  //     const rect = room.getBoundingClientRect();
  //     return {
  //         left: rect.left + window.scrollX,
  //         top: rect.top
  //     };
  // }

  // const thumbnail = room.querySelector(".js-thumbnail-hover");
  // const pos = { x: room.clientWidth / 2, y: room.clientHeight / 2 };
  // const mouse = { x: pos.x, y: pos.y };
  // const speed = 0.15;
  // const xSet = gsap.quickSetter(thumbnail, "x", "px");
  // const ySet = gsap.quickSetter(thumbnail, "y", "px");
  // const thumbnailAnimationTL = gsap.timeline().pause(0);

  // thumbnailAnimationTL.fromTo(thumbnail,
  //     {opacity: 0, width: 0, height: 0, left: 0, top: 0, duration: 0},
  //     {opacity: 1, width: '224px', height: '384px', left: '-112px', top:'-192px', duration: 0.5}
  // );

  // room.addEventListener('mouseenter', () => {
  //     thumbnailAnimationTL.play();
  // });

  // room.addEventListener('mouseleave', () => {
  //     thumbnailAnimationTL.reverse();
  // });

  // room.addEventListener("mousemove", e => {

  //     if((e.x > roomPosition(room).left && e.x < (roomPosition(room).left + room.clientWidth)) &&
  //         (e.y > roomPosition(room).top && e.y < (roomPosition(room).top + room.clientHeight))){
  //             thumbnail.classList.add('block');
  //             thumbnail.classList.remove('hidden');
  //     }else{
  //         thumbnail.classList.remove('block');
  //         thumbnail.classList.add('hidden');
  //     }

  //     mouse.x = e.x - (roomPosition(room).left/1.5);
  //     mouse.y = e.y - roomPosition(room).top;

  // });

  // gsap.ticker.add(() => {
  //     // adjust speed for higher refresh monitors
  //     const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());
  //     pos.x += (mouse.x - pos.x) * dt;
  //     pos.y += (mouse.y - pos.y) * dt;
  //     xSet(pos.x);
  //     ySet(pos.y);
  // });
  //     }
  // }

  const lightboxHoverArea = document.querySelector('.js-gallery-slider-area');
  const thumbnail = document.querySelector('.js-gallery-lightbox-hover');

  if (lightboxHoverArea) {
    const onMouseMove = (e) => {
      gsap.to(thumbnail, {
        duration: 0.4,
        x: e.offsetX,
        y: e.offsetY,
        backgroundColor: '#000',
        borderColor: '#000',
      });
    };

    const onMouseLeave = (e) => {
      const rect = lightboxHoverArea.getBoundingClientRect();
      const center = {
        w: Math.round(rect.width * 0.5),
        h: Math.round(rect.height * 0.5),
      };

      gsap.to(thumbnail, {
        duration: 0.7,
        x: center.w,
        y: center.h,
        backgroundColor: 'transparent',
        borderColor: '#fff',
      });
    };

    onMouseLeave();

    lightboxHoverArea.addEventListener('mouseleave', onMouseLeave);

    lightboxHoverArea.addEventListener('mousemove', onMouseMove);

    lightboxHoverArea.addEventListener('click', () => {
      lightboxHoverArea
        .querySelectorAll('.swiper-slide-active')[0]
        .querySelector('a');
    });

    lightboxHoverArea.addEventListener('mouseup', () => {
      gsap.to(thumbnail, {
        scale: 1,
        duration: 0.1,
      });
    });

    lightboxHoverArea.addEventListener('mousedown', () => {
      gsap.to(thumbnail, {
        duration: 0.3,
        scale: 0.95,
      });
    });
  }

  if (window.outerWidth > 768) {
    if (primaryButtons) {
      for (const primaryButton of primaryButtons) {
        const tl = gsap.timeline().pause(0);

        tl.to(primaryButton.children[1], {
          x: '445px',
          width: 0,
          duration: 0.2,
          ease: 'power1.in',
        });

        tl.to(primaryButton.children[0], {
          x: '-8px',
          width: 'auto',
          duration: 0.2,
          ease: 'power1.Out',
        });

        primaryButton.addEventListener('mouseenter', () => {
          if (primaryButton.parentElement.disabled) {
            return false;
          }
          tl.play();
        });

        primaryButton.addEventListener('mouseleave', () => {
          tl.reverse();
        });
      }
    }

    if (iconButtons) {
      for (const iconButton of iconButtons) {
        const tl = gsap.timeline().pause(0);
        const getX1 = iconButton.classList.contains('to-left')
          ? '-2px'
          : '50px';
        const getX2 = iconButton.classList.contains('to-left')
          ? '-50px'
          : '2px';

        if (iconButton.classList.contains('to-left')) {
          tl.to(iconButton.children[0], {
            x: getX2,
            width: 0,
            duration: 0.2,
            ease: 'power1.in',
          });

          tl.to(iconButton.children[1], {
            x: getX1,
            width: 'auto',
            duration: 0.2,
            ease: 'power1.in',
          });
        } else {
          tl.to(iconButton.children[1], {
            x: getX1,
            width: 0,
            duration: 0.2,
            ease: 'power1.in',
          });

          tl.to(iconButton.children[0], {
            x: getX2,
            width: 'auto',
            duration: 0.2,
            ease: 'power1.in',
          });
        }

        iconButton.addEventListener('mouseenter', () => {
          tl.play();
        });

        iconButton.addEventListener('mouseleave', () => {
          tl.reverse();
        });
      }
    }
  }
}
